<template>
    <v-sheet>
        <div class="mb-40">
            <v-chip-group class="mb-8">
                <v-chip outlined label color="primary">
                    <span class="font-size-14"> {{ program._employees.length.format() }}명 참여 </span>
                </v-chip>
                <v-chip outlined label color="secondary">
                    <span class="font-size-14"> {{ program._employers.length.format() }}개 기업 참여 </span>
                </v-chip>
            </v-chip-group>
            <h5 class="tit--lg mb-8">
                {{ program.subject }}
            </h5>
            <p class="page-text--lg primary--text">
                {{ program.host.name }}
            </p>
        </div>
        <div>
            <v-row class="ma-n4">
                <v-col cols="12" class="pa-4">
                    <expo-program-apply v-bind="{ program }">
                        <template #activator="{ attrs, on, loading, isNext }">
                            <template v-if="isNext">
                                <v-btn large block outlined color="grey-d" v-bind="{ ...attrs, disabled, loading }" v-on="on">
                                    <span class="grey--text"> 프로그램 참여정보 </span>
                                </v-btn>
                            </template>
                            <template v-else>
                                <v-btn large block color="primary" v-bind="{ ...attrs, disabled, loading }" v-on="on"> 신청하기 </v-btn>
                            </template>
                        </template>
                    </expo-program-apply>
                </v-col>
                <v-col class="pa-4">
                    <v-btn large outlined block color="grey-d" v-bind="{ disabled, loading }" @click="share">
                        <span class="grey--text">공유하기</span>
                        <v-icon size="21px" class="ml-10 grey--text">mdi-share-variant-outline</v-icon>
                    </v-btn>
                </v-col>
                <v-col class="pa-4">
                    <like-btn :params="params__likeBtn">
                        <template #activator="{ active, loading, toggle }">
                            <v-btn
                                v-bind="{
                                    color: active ? 'yellow darken-1' : 'grey-d',
                                    disabled,
                                    loading,
                                }"
                                large
                                outlined
                                block
                                @click="toggle"
                            >
                                <v-layout
                                    justify-center
                                    align-baseline
                                    :class="{
                                        ['grey--text']: !active,
                                    }"
                                >
                                    <span> 관심행사 </span>
                                    <v-icon size="21px" class="ml-10">
                                        {{ active ? "mdi-bookmark" : "mdi-bookmark-outline" }}
                                    </v-icon>
                                </v-layout>
                            </v-btn>
                        </template>
                    </like-btn>
                </v-col>
            </v-row>
        </div>
    </v-sheet>
</template>

<script>
import { USER_LIKE_TYPES } from "@/assets/variables/constants";
import { initExpoProgram } from "@/assets/variables/inits";

import LikeBtn from "@/components/client/like/like-btn.vue";
import ExpoProgramApply from "@/components/client/expo/programs/expo-program-apply.vue";

export default {
    components: {
        LikeBtn,
        ExpoProgramApply,
    },
    props: {
        program: { type: Object, default: initExpoProgram },
        isPreview: { type: Boolean, default: false },
    },
    data: () => ({
        loading: false,
    }),
    computed: {
        disabled() {
            return this.isPreview || !this.program.isGranted;
        },
        params__likeBtn() {
            return {
                _expoprogram: this.program._id,
                type: USER_LIKE_TYPES.EXPOPROGRAM.value,
            };
        },
    },
    methods: {
        async share() {
            this.loading = true;

            await navigator.share({
                title: this.program.subject,
                text: this.program.summary,
                url: document.location.href,
            });

            this.loading = false;
        },
    },
};
</script>

<style>
</style>